<template lang="pug">
v-footer.mt-auto(color="transparent" padless v-if="!isHidden")
  v-container.py-5.d-flex.justify-space-between(fluid)
    div
      v-tooltip(
        top
        v-for="(link, idx) in footerLinks"
        :key="idx"
      ) {{ link.tooltip }}
        template(v-slot:activator="{ on }")
          v-btn(
            v-on="{ ...on, ...link.listeners }"
            :icon="!link.text"
            :href="link.href"
            target="_blank"
          )
            v-icon(
              v-if="link.icon"
              color="#636363"
              :left="!!link.text"
            ) {{ link.icon }}
            v-img(
              v-else
              :src="link.image"
              contain
              height="24px"
              max-width="24px"
            )
            |  {{ link.text }}

</template>
<script>
import vchtLogo from '@/assets/vcht/vcht.png';
import fcdoLogo from '@/assets/vcht/fcdo.png';
import fcomofvLogo from '@/assets/vcht/fcomofv.png';

export default {
  props: {
    showAgreement: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    links: [],
  }),
  computed: {
    footerLinks() {
      if (this.$conf.isVcht) {
        return this.linksVcht;
      }
      return this.links;
    },
    linksVcht() {
      return [
        {
          href: 'http://vcht.center/',
          image: vchtLogo,
          tooltip: 'ВЦХТ',
        },
        {
          href: 'https://fedcdo.ru/',
          image: fcdoLogo,
          tooltip: 'ФЦДО',
        },
        {
          href: 'https://xn--b1atfb1adk.xn--p1ai/',
          image: fcomofvLogo,
          tooltip: 'ФЦОМОФВ',
        },
        {
          icon: 'mdi-at',
          text: 'bo@fedcdo.ru',
          tooltip: 'bo@fedcdo.ru',
          listeners: {
            click: () => this.$root.$emit('openSupportModal'),
          },
        },
        {
          icon: 'mdi-information-outline',
          text: 'Контакты региональных организаторов',
          tooltip: 'Контакты региональных организаторов',
          listeners: {
            click: () => this.$root.$emit('openContactsModal'),
          },
        },
        // {
        //   href: 'tel:+79310091438',
        //   icon: 'mdi-phone-in-talk',
        //   tooltip: 'Телефон',
        //   text: '+7-931-009-1438',
        // },
      ];
    },
    isHidden() {
      const { name } = this.$route;
      return [
        'ui-event-landing',
        'event-dashboard-main',
        'redesign-event-create',
      ].includes(name);
    },
  },
};
</script>
